import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AskJDSNavbar } from './AskJDSNavbar';
import { Footer } from '@/components/shared/Footer';

interface PageLayoutProps {
  children: ReactNode;
}

export default function PageLayout({ children }: PageLayoutProps) {
  const location = useLocation();

  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div className="flex flex-col min-h-screen">
      <AskJDSNavbar />
      <main className="flex-grow pt-16 pb-[env(safe-area-inset-bottom)] md:pb-0">
        {children}
      </main>
      <Footer />
    </div>
  );
}
